'use strict'

import TransferItem from './transferitem.coffee'

class FolderItem extends TransferItem
  _updateTotalCount: (deltaCount, deltaSize) ->
    if deltaCount or deltaSize
      folder = this
      while folder
        # Update the number of pending files in the directory
        folder.totalFileCount += deltaCount
        folder.totalFileSize += deltaSize

        # Move to the parent folder
        folder = folder.folder

    # Allow chaining
    this

  _updatePendingCount: (deltaCount, deltaSize) ->
    if deltaCount or deltaSize
      folder = this
      while folder
        # Update the number of pending files in the directory
        pendingFileCount = (folder.pendingFileCount || 0) + deltaCount
        pendingFileSize = (folder.pendingFileSize || 0) + deltaSize

        # This field only exists when it's non-zero
        if pendingFileCount
          folder.pendingFileCount = pendingFileCount
          folder.pendingFileSize = pendingFileSize
        else
          delete folder.pendingFileCount
          delete folder.pendingFileSize

        # Move to the parent folder
        folder = folder.folder

    # Allow chaining
    this

  _updateSelectionCount: (deltaCount, deltaSize) ->
    if deltaCount or deltaSize
      folder = this
      while folder
        # Update the number of selected files in the directory
        selectedFileCount = (folder.selectedFileCount || 0) + deltaCount
        selectedFileSize = (folder.selectedFileSize || 0) + deltaSize

        # This field only exists when it's non-zero
        if selectedFileCount
          folder.selectedFileCount = selectedFileCount
          folder.selectedFileSize = selectedFileSize
        else
          delete folder.selectedFileCount
          delete folder.selectedFileSize

        # Move to the parent folder
        folder = folder.folder

    # Allow chaining
    this

  _updateFolderCount: (transferItem, factor) ->
    # Determine the number of sub files
    totalFileCount = transferItem.getTotalFileCount() * factor
    totalFileSize = transferItem.getTotalFileSize() * factor
    selectedFileCount = transferItem.getSelectedFileCount() * factor
    selectedFileSize = transferItem.getSelectedFileSize() * factor
    pendingFileCount = transferItem.getPendingFileCount() * factor
    pendingFileSize = transferItem.getPendingFileSize() * factor

    # If there are sub files, then we need to update the folder count (and all its parents)
    @_updateTotalCount totalFileCount, totalFileSize
    @_updateSelectionCount selectedFileCount, selectedFileSize
    @_updatePendingCount pendingFileCount, pendingFileSize

    # Allow chaining
    this

  _selectItem: ->
    # Don't do anything if all files have already been selected
    if @totalFileCount == (@selectedFileCount || 0)
      return false

    # Select all sub items
    for subItem in @subItems
      subItem._selectItem()

    # All files have been selected
    @selectedFileCount = @totalFileCount
    @selectedFileSize = @totalFileSize
    return true

  _deselectItem: ->
    # Don't do anything if no files have been selected
    if @selectedFileCount == 0
      return false

    # Deselect all sub items
    for subItem in @subItems
      subItem._deselectItem()

    # All files are selected anymore
    delete @selectedFileCount
    delete @selectedFileSize
    return true

  @createFromTransfer: (transferFolder) ->
    folderItem = new FolderItem()
    folderItem.updateFromTransfer transferFolder
    return folderItem

  @createFromBlob: (id, blob) ->
    folderItem = new FolderItem()
    folderItem.updateFromBlob blob
    return folderItem

  constructor: (id, name) ->
    # Call base
    super id, name

    @subItems = []
    @totalFileCount = 0
    @totalFileSize = 0

  addItem: (transferItem) ->
    # Remove the item from the folder it currently belongs to
    if transferItem.folder
      transferItem.folder.removeItem transferItem

    # Add the item to the current folder
    @subItems.push transferItem
    transferItem.folder = this

    # Update the folder count
    @_updateFolderCount transferItem, 1

    # Allow chaining
    this

  removeItem: (transferItem) ->
    # Check if the item is in the folder
    itemIndex = @subItems.indexOf transferItem
    if itemIndex >= 0
      # Remove it from the folder
      @subItems.splice itemIndex, 1

      # Remove the link to the folder
      delete transferItem.folder

      # Update the folder count
      @_updateFolderCount transferItem, -1

    # Allow chaining
    this

  selectItem: ->
    # Select all non-selected files
    itemCount = @totalFileCount - (@selectedFileCount || 0)
    itemSize = @totalFileSize - (@selectedFileSize || 0)
    if itemCount or itemSize
      # Select all items
      @_selectItem()

      # Update the parent folder counts as well
      if @folder
        @folder._updateSelectionCount itemCount, itemSize

    # Allow chaining
    this

  deselectItem: ->
    # Deselect all selected files
    itemCount = @selectedFileCount || 0
    itemSize = @selectedFileSize || 0
    if itemCount or itemSize
      # Deselect all items
      @_deselectItem()

      # Update the parent folder counts as well
      if @folder
        @folder._updateSelectionCount -itemCount, -itemSize

    # Allow chaining
    this

  getSelectionStatus: ->
    if !@selectedFileCount
      return 'NONE'
    else if @selectedFileCount < @totalFileCount
      return 'PARTIAL'
    else
      return 'ALL'

  getTotalFileCount: -> @totalFileCount
  getTotalFileSize: -> @totalFileSize
  getSelectedFileCount: -> @selectedFileCount || 0
  getSelectedFileSize: -> @selectedFileSize || 0
  getPendingFileCount: -> @pendingFileCount || 0
  getPendingFileSize: -> @pendingFileSize || 0

  getFriendlyFileType: ->
    'folder'

export default FolderItem
